import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
    selector: 'formly-field-custom-ppe',
    template: `
  <div class="d-flex flex-column align-items-center">
    <div class="btn btn-primary qr-button">
        <span class="qr-text">Detect a PPE from <br> the Camera</span>
    </div>
  </div>
  `,
    styles: ['btn-primary{background-color: #003DA6;border-color: #003DA6;width: 117px; height: 30px;border-radius: 4px;display: flex;flex-direction: row;justify-content: center;align-items: center;padding: 11px 12px;}'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormlyFieldCustomPpe extends FieldType<FieldTypeConfig> {
  get type() {
    return this.to.type || 'text';
  }
}